module.exports = __webpack_public_path__ + "img/404-not-found.ce68ff00.png";